export const Skelton = {
  defaultProps: {
    speed: 0.6,
  },
};
